// components/Notifications/NotificationIcon.jsx
import React from "react";
import { Warning, CheckCircle, Error, Info, Flag, FiberManualRecord } from "@mui/icons-material";

const NotificationIcon = ({ type }) => {
  if (!type) return <FiberManualRecord sx={{ color: "#8b5cf6", fontSize: 18 }} />;

  const typeLower = type.toLowerCase();

  if (typeLower.includes("breached") || typeLower.includes("late")) {
    return <Warning sx={{ color: "#ef4444", fontSize: 18 }} />;
  }
  if (typeLower.includes("allocated")) {
    return <CheckCircle sx={{ color: "#22c55e", fontSize: 18 }} />;
  }
  if (typeLower.includes("unallocated") || typeLower.includes("removed")) {
    return <Error sx={{ color: "#f59e0b", fontSize: 18 }} />;
  }
  if (typeLower.includes("flag")) {
    return <Flag sx={{ color: "#ef4444", fontSize: 18 }} />;
  }
  return <Info sx={{ color: "#3b82f6", fontSize: 18 }} />;
};

export default NotificationIcon;